import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { detailToSaveInput } from '../lib/detailToSaveInput';
import { workflowDetailDtoSchema } from '../schemas/workflowSchemas';
import { workflowKeys } from './workflowKeys';

// Rename a workflow in place. There is no dedicated rename endpoint — the only
// update path is the full PUT — so we fetch the current detail, re-serialise it
// unchanged except for the name, and save. Every step/rule/binding is preserved.
export function useRenameWorkflow() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: async ({ workflowId, name }: { workflowId: string; name: string }) => {
      const raw = await apiClient.get(`api/v1/t/${tenantId}/workflows/${workflowId}`).json();
      const detail = workflowDetailDtoSchema.parse(raw);
      const body = detailToSaveInput(detail, { name });
      const saved = await apiClient
        .put(`api/v1/t/${tenantId}/workflows/${workflowId}`, { json: body })
        .json();
      return workflowDetailDtoSchema.parse(saved);
    },
    onSuccess: (data) => {
      qc.setQueryData(workflowKeys.detail(data.id), data);
      qc.invalidateQueries({ queryKey: workflowKeys.lists() });
    },
  });
}
